import { visionApi } from '@/api/axiosInstance';
import {
  PredictLicensePlateRequest,
  PredictLicensePlateResponse,
} from './predict.types';
import { getUserFromLocalStorage } from '@/utils/user';

const BASE = '/predict/license-plate';

export default {
  async licensePlate(data: PredictLicensePlateRequest) {
    const formData = new FormData();
    formData.append('image', data.image);

    const { accessToken } = getUserFromLocalStorage();

    const result = await visionApi.post<PredictLicensePlateResponse>(
      `${BASE}`,
      formData,
      {
        headers: {
          'Content-Type': 'multpart/form-data',
          Authorization: `Bearer ${accessToken}`,
          'x-custom-api-url': process.env.REACT_APP_API_URL,
        },
        timeout: 30000,
      },
    );
    return result.data;
  },
};
